(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('AudioIbqDetailController', AudioIbqDetailController);

    AudioIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Audio', 'Disc', 'MusicalPiece', 'Person', 'Copyright'];

    function AudioIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Audio, Disc, MusicalPiece, Person, Copyright) {
        var vm = this;

        vm.audio = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:audioUpdate', function(event, result) {
            vm.audio = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
